<template>
    <div class="hold-transition sidebar-mini layout-fixed">
        <div class="wrapper">

            <top-navigation/>
            <fixed-navbar/>
            <box-content/>
        </div>
    </div>
</template>
    
<script>
import FixedNavbar from '@/components/FixedNavbar.vue'
import BoxContent from '@/components/BoxContent.vue'
import TopNavigation from '@/components/TopNavigation.vue'
    

export default {
    components: {
        BoxContent,
        FixedNavbar,
        TopNavigation
    }
}
</script>

<style>

</style>